class CategoryCard

  constructor: (@$parent)->
    @init()

  init: ->
    _t = @

    @$wrapper = @$parent.find('.globalNav_item_categoryCard')
    @$lists = @$parent.find('.globalNav_item_subNav li')

  changeCard: (index)->

    @$lists.removeClass('c_active')
    @$lists.eq(index).addClass('c_active')

    @$wrapper.find('.categoryCard').removeClass('active');
    @$wrapper.eq(index).find('.categoryCard').addClass('active')

    @$wrapper
      .css
        'z-index': 1
    @$wrapper.eq(index)
      .css
        'z-index': 2
      .animate
        right: 0
      , 300, =>
        @$wrapper.not(@$wrapper.eq(index)).css
          right: '60%'



module.exports = CategoryCard


// WEBPACK FOOTER //
// ./src/scripts/modules/CategoryCard.coffee